// extracted by mini-css-extract-plugin
export var lg = "_4e-4";
export var md = "_4e-3";
export var sm = "_4e-2";
export var xs = "_4e-1";
export var xxs = "_4e-0";